<template lang="pug">
    validation-provider(tag="label" :name="name")
        input.radio-component(
            type="radio"
            :checked="value"
            :disabled="disabled"
            :value="value"
            @input="$emit('input', $event.target.checked)"
            ref="radio"
            )
        slot
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  name: "RadioBtn",
  components: { ValidationProvider },
  props: {
    value: Boolean,
    disabled: Boolean,
    name: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="stylus">
input[type="radio"]:focus
    outline 0
    outline-offset 0

input[type="radio"]:disabled
    opacity .5

.radio-component
    appearance none
    position relative
    cursor pointer
    margin-right 10px!important

.radio-component:before
    content ""
    width 15px
    height 15px
    border-radius 50%
    border solid 1px #ccc
    display inline-block
    background #fff

.radio-component:checked:after
    content  ''
    position absolute
    left 2px
    top 2px
    width 11px
    height 11px
    border-radius 50%
    background-color button-background-color
</style>
